import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Button,
  Table,
  Menu,
  Dropdown,
  message,
  Input,
  Spin,
} from "antd";
import "./EquipmentCostsC.less";
import { miscHeader, travelCostColumns } from "./config";
import api from "../../utils/api";
import { SearchOutlined } from "@ant-design/icons";
import { MoreActionIcon } from "../../utils/icons";
import AddAdminRates from "../../components/pop-ups/default-modal/AddAdminRates";
import DefaultBulkEntry from "../../components/pop-ups/default-modal/MaterialDefaultBulkEntry";
import { CSVLink } from "react-csv";

type travelType = {
  _id: string;
  item: string;
  cost: string;
};

const TravelCostC = () => {
  const [travelCost, setTravelCost] = useState<travelType[]>([]);
  const [showSingleItemModal, setShowSingleItemModal] = useState(false);
  const [travelSearched, setTravelSearched] = useState("");
  const [buttonDisable, setButtonDisable] = useState(false);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [item, setItem] = useState<any>({});
  const [edit, setEdit] = useState(false);
  useEffect(() => {
    api
      .get("rates/cost/travel")
      .then((resp: any) => {
        setTravelCost(resp);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);
  const handleDelete = (id: string) => {
    api.delete(`rates/travel/${id}`).then(() => {
      setTravelCost(travelCost.filter((item: any) => item._id !== id));
    });
  };

  const handleAdd = (values: any) => {
    if (edit) {
      api.put(`rates/travel/${item._id}`, values).then((resp: any) => {
        setTravelCost(
          travelCost.map((data: any) =>
            data._id === item._id ? { ...values, _id: item._id } : data
          )
        );
      });
    } else {
      api
        .post("rates", {
          category: "travel",
          rate: values,
        })
        .then((resp: any) => {
          setTravelCost([...travelCost, resp]);
        });
    }
    toggleSingleItemModal();
  };

  const found = travelCost?.filter((item: any) => {
    if (!travelSearched) {
      return true;
    }
    return item.item.toLowerCase().includes(travelSearched.toLowerCase());
  });
  const sortedFound = [...found].sort((a: any, b: any) =>
    a.item.localeCompare(b.item)
  );

  const toggleSingleItemModal = () => {
    !showSingleItemModal
      ? setShowSingleItemModal(true)
      : setShowSingleItemModal(false);
  };

  const handleSingleItem = () => {
    setEdit(false);
    setItem({});
    toggleSingleItemModal();
  };

  const handleEdit = (data: any) => {
    setItem(data);
    setEdit(true);
    toggleSingleItemModal();
  };

  const handleAddCsv = (info: any) => {
    setButtonDisable(true);
    if (info.file.status === "done") {
      setButtonDisable(false);
      message.success("Successfully Uploaded");
      const resp = info.file.response.data;
      setTravelCost(resp);
      toggleBulkModal();
    } else if (info.file.status === "error") {
      setButtonDisable(false);
      message.error("Uploading Failed!");
    }
  };

  const toggleBulkModal = () => {
    !showBulkModal ? setShowBulkModal(true) : setShowBulkModal(false);
  };

  const tableColumns = [
    ...travelCostColumns,
    {
      title: "Action",
      width: 100,
      render: (data: any) => {
        return (
          <Dropdown
            overlay={
              <Menu>
                <Menu.Item
                  key="edit"
                  style={{ fontWeight: "bold" }}
                  onClick={() => handleEdit(data)}
                >
                  Edit
                </Menu.Item>
                <Menu.Item
                  key="delete"
                  style={{ fontWeight: "bold" }}
                  onClick={() => handleDelete(data._id)}
                >
                  Delete
                </Menu.Item>
              </Menu>
            }
            trigger={["click"]}
          >
            <div style={{ cursor: "pointer" }}>
              <MoreActionIcon />
            </div>
          </Dropdown>
        );
      },
    },
  ];
  const handleBulkBtn = () => {
    !showBulkModal ? setShowBulkModal(true) : setShowBulkModal(false);
  };

  return (
    <div className="admin-ec-root">
      <DefaultBulkEntry
        buttonDisable={buttonDisable}
        showBulkModal={showBulkModal}
        toggleBulkModal={toggleBulkModal}
        url="rates/upload"
        handleAddCsv={handleAddCsv}
      />
      <AddAdminRates
        toggleSingleItemModal={toggleSingleItemModal}
        handleAdd={handleAdd}
        showSingleItemModal={showSingleItemModal}
        item={item}
        edit={edit}
      />
      <Row className="admin-ec-header" justify="space-between">
        <Col>
          <h1>Travel Labor Rates</h1>
        </Col>
        <Row gutter={12}>
          <Col>
            <Input
              className="search-manufacture-input"
              prefix={
                <SearchOutlined className="contractor-data-search-icon" />
              }
              placeholder="Search Travel"
              onChange={(e) => {
                setTravelSearched(e.target.value);
              }}
            />
          </Col>
          <div className="contractor-data-vertical-line " />
          <Col>
            <Button
              className="admin-ec-add-single-btn"
              onClick={handleSingleItem}
            >
              Add Single item
            </Button>
          </Col>
          <Col>
            <Button
              className="admin-ec-add-btn"
              type="primary"
              onClick={handleBulkBtn}
            >
              Bulk Entry
            </Button>
          </Col>
        </Row>
      </Row>
      {loading ? (
        <Row style={{ padding: "80px 0px" }} justify="center">
          <Spin size="large" />
        </Row>
      ) : (
        <>
          <hr style={{ border: "1px solid #E8E8E8", marginBottom: 30 }} />

          <Button
            className="default-bulk-btn"
            style={{ margin: "0px 20px 10px" }}
            type="primary"
          >
            <CSVLink
              data={travelCost}
              filename={"travel-rates"}
              headers={miscHeader}
              enclosingCharacter={""}
            >
              Download CSV
            </CSVLink>
          </Button>
          {travelCost.length > 0 && (
            <Table
              scroll={{ x: "900px" }}
              rowKey="_id"
              columns={tableColumns}
              dataSource={sortedFound}
            />
          )}
        </>
      )}
    </div>
  );
};

export default TravelCostC;
